import { lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AdminRoute } from './components/AdminRoute';
import { LazyRouteBoundary } from './components/ChunkErrorBoundary';
import { ScrollToTop } from './components/ScrollToTop';
import { ManagerRoute } from './manager/ManagerRoute';
import { Router } from './pages/Router';

// 관리자·매니저 화면은 일반 방문자가 열지 않는다. 첫 JS에 넣지 않고 진입할 때 받는다.
// (관리자 편집기 Froala 등 무거운 의존성이 이 덩어리에만 들어간다.)
const Admin = lazy(() =>
  import('./admin/Admin').then((m) => ({ default: m.Admin }))
);
const AlimtalkTestGuidePage = lazy(
  () => import('./admin/pages/alimtalk-test-guide/AlimtalkTestGuidePage')
);
const Manager = lazy(() =>
  import('./manager/Manager').then((m) => ({ default: m.Manager }))
);
const ManagerLogin = lazy(() =>
  import('./manager/pages/login/ManagerLogin').then((m) => ({
    default: m.ManagerLogin,
  }))
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <LazyRouteBoundary>
        <Routes>
          <Route path="admin/*" element={<AdminRoute element={<Admin />} />} />
          <Route path="manager/login" element={<ManagerLogin />} />
          <Route
            path="manager/*"
            element={<ManagerRoute element={<Manager />} />}
          />
          {/* 공개 라우트(로그인 불필요) — 클라이언트 공유용 알림톡 테스트 가이드 */}
          <Route
            path="alimtalk-test-guide"
            element={<AlimtalkTestGuidePage />}
          />
          <Route path="*" element={<Router />} />
        </Routes>
      </LazyRouteBoundary>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
